import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { post } from "../../api/client";
import { Button } from "../../components/ui/Button";
import { TextField } from "../../components/ui/Field";
import { InlineError } from "../../components/ui/misc";
import { AuthLayout } from "./AuthLayout";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await post("/auth/password/forgot", { email });
      setSent(true);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Reset your password">
      {sent ? (
        <div className="space-y-4">
          <p role="status" className="text-sm text-default">If an active account exists for <strong>{email}</strong>, we've sent a reset link. It expires in 60 minutes.</p>
          <Link className="text-sm text-accent-600 hover:underline" to="/login">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <TextField label="Email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          <InlineError error={error} />
          <Button type="submit" variant="primary" className="w-full" loading={busy}>Send reset link</Button>
          <p className="text-center text-sm"><Link className="text-accent-600 hover:underline" to="/login">Back to sign in</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}
